import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './BaseLoading.css';
var BaseLoading = function () {
    return (_jsx("div", { className: 'w-full h-full absolute top-0 left-0 flex items-center justify-center bg-[#ffffff60]', style: {
            zIndex: 9999
        }, children: _jsxs("div", { className: 'lds-ring', children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {})] }) }));
};
export default BaseLoading;
